/*
 * @Author: 鱿鱼须
 * @LastEditors: 鱿鱼须 && xxxxxxxxxx@qq.com
 * @LastEditTime: 2025-01-15 11:09:44
 * @FilePath: \吕工空调-admin\src\main.js
 * @Description: 描述
 */
import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import router from './router'
import store from './store'
//图标
import 'font-awesome/css/font-awesome.css'
//进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
//引入常量 dm
import cfg from "./config"
//预览图片
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

const app = createApp(App)
    .use(store)
    .use(router)
    .use(cfg)
    .use(ElementPlus,{locale: zhCn})
    .use(Viewer, {
    Options: {
            'inline': true,
            'button': true, //右上角按钮
            "navbar": true, //底部缩略图
            "title": true, //当前图片标题
            "toolbar": true, //底部工具栏
            "tooltip": true, //显示缩放百分比
            "movable": true, //是否可以移动
            "zoomable": true, //是否可以缩放
            "rotatable": true, //是否可旋转
            "scalable": true, //是否可翻转
            "transition": true, //使用 CSS3 过度
            "fullscreen": true, //播放时是否全屏
            "keyboard": true, //是否支持键盘
            "url": "data-source",
        }
    })
    app.mount('#app')

router.beforeEach((to, from, next) =>
{
    NProgress.start() // 进度条开始
    let token = localStorage.getItem('Token');
    let path = to.path;
    if (path == '/Login') {
        next();
        return;
    }
    //以防无限循环
    if (token) {
        if (to.matched.length === 0) {
            window.localStorage.removeItem("quickMenu");
            window.localStorage.removeItem("active");
            next('/404');
            return;
        }
        next();
    } else {
        next({
            path: '/Login',
        });
    }
});


router.afterEach(() => {
    NProgress.done() // 进度条结束
})
